import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { GridButton } from '@components/data-grid';
import { LongActionButtonComponent } from '@components/long-action-button/long-action-button.component';
import { TooltipDirective } from '@directives';
import { MotifButtonModule, MotifIconModule } from '@ey-xd/ng-motif';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-grid-button',
  standalone: true,
  imports: [LongActionButtonComponent, MotifButtonModule, MotifIconModule, TranslatePipe, TooltipDirective],
  templateUrl: './grid-button.component.html',
  styleUrl: './grid-button.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GridButtonComponent {
  readonly #translateService = inject(TranslateService);

  public readonly button = input.required<GridButton>();

  public readonly translatedTooltip = computed(() => {
    return this.button().tooltip ? this.#translateService.instant(this.button().tooltip!) : undefined;
  });

  public readonly isDisabled = computed(() => {
    return this.button().isDisabled ? this.button().isDisabled!() : false;
  });

  onActionClick(): void {
    this.button().onClick();
  }

  onLongActionClick(): Observable<boolean> {
    return this.button().onClick() as Observable<boolean>;
  }
}
